<template>
  <div @mouseover="isHovered = true" @mouseleave="isHovered = false">
    <span class="text-xsmall">{{ buttonTxt }}</span>
    <img
      :src="isHovered ? playIconHover : playIcon"
      class="icon-right"
      alt="Icon"
    />
  </div>
</template>

<script setup>
import playIcon from '@/assets/img/ico/play.svg?url'
import playIconHover from '@/assets/img/ico/play-hover.svg?url'

const props = defineProps({
  buttonTxt: {
    type: String,
    default: 'Play',
  },
})

const isHovered = ref(false)
</script>

<script>
export default {
  name: 'PlayBtn',
}
</script>
